import { ResultCell } from './ResultCell';
import { For, type JSX } from 'solid-js';

export interface CellData {
  label: string;
  value: string;
  testId?: string;
  valueTestId?: string;
}

export interface ResultRowProps {
  cells: CellData[];
  testId?: string;
}

export const ResultRow = (props: ResultRowProps): JSX.Element => {
  return (
    <div class="flex bg-gray-light p-3" data-testid={props.testId}>
      <For each={props.cells}>
        {(cell) => (
          <ResultCell
            label={cell.label}
            value={cell.value}
            testId={cell.testId}
            valueTestId={cell.valueTestId}
          />
        )}
      </For>
    </div>
  );
};
